import { ApiClient } from './client';
import type { UserCredits } from '@/lib/stores/credits-store';

class WelcomeRewardApi extends ApiClient {
  claim() {
    return this.request<{ already_claimed: boolean; amount: number; credits: UserCredits }>(
      '/credits/welcome/claim', { method: 'POST' },
    );
  }
}

export const welcomeRewardApi = new WelcomeRewardApi();
